var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4004",
    "data-name": "Rectangle 4004",
    width: 24,
    height: 24,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clock",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7656",
    "data-name": "Group 7656",
    transform: "translate(2.501 2.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7655",
    "data-name": "Group 7655"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8255",
    "data-name": "Path 8255",
    d: "M0,10.058V8.944c.012-.066.025-.131.034-.2.059-.409.093-.823.181-1.226A9.226,9.226,0,0,1,3.741,1.964,9.216,9.216,0,0,1,11.495.224a9.171,9.171,0,0,1,5.532,3.5,9.237,9.237,0,0,1,1.922,6.727,9.176,9.176,0,0,1-2.317,5.31,9.328,9.328,0,0,1-5.495,3.09c-.358.064-.72.1-1.08.148H8.943a1.014,1.014,0,0,0-.143-.031,9.042,9.042,0,0,1-4.145-1.307A9.375,9.375,0,0,1,.148,11.135c-.066-.356-.1-.718-.148-1.078m9.5-8.58A8.023,8.023,0,1,0,17.524,9.5,8.028,8.028,0,0,0,9.5,1.478",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8256",
    "data-name": "Path 8256",
    d: "M188.51,97.828c0-.717,0-1.434,0-2.152a.738.738,0,0,1,1-.732.756.756,0,0,1,.477.764c0,1.255,0,2.51,0,3.765a.364.364,0,0,0,.17.334q1.223.9,2.434,1.823a.735.735,0,1,1-.845,1.2c-.466-.337-.921-.688-1.381-1.032-.49-.367-.975-.741-1.47-1.1a.88.88,0,0,1-.384-.776c.006-.7,0-1.4,0-2.1",
    transform: "translate(-179.749 -90.485)",
    fill: "#0a64f9"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.1a59f26c0a39500236b4e1ef44850868.svg";
export { ForwardRef as ReactComponent };